import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { useHits } from 'react-instantsearch-hooks-web';
import styles from './ResultCount.module.scss';

export const ResultCount: React.FC = () => {
	const { results } = useHits();

	return (
		<div
			aria-live='polite'
			className={`${styles.resultsCount} ${
				results.query
					? styles.activeSearchResultsLabelContainer
					: styles.noActiveSearchResultsLabelContainer
			}`}
		>
			<Typography className={styles.header} variant='h5'>
				<span className='weglot-exclude' data-testid='search-results-number'>
					{results.nbHits}
				</span>
				<span data-testid='search-results-text'> result{results.nbHits === 1 ? '' : 's'}</span>
			</Typography>
		</div>
	);
};
